import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Flag, Lock, Mail } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;

    setLoading(true);
    try {
      const res = await fetch(`${API}/admin/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email: email.trim(), password }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || "Error de autenticacion");
      }

      const data = await res.json();
      if (data.session_token) {
        localStorage.setItem("cadii_admin_token", data.session_token);
      }
      localStorage.setItem("cadii_admin_user", JSON.stringify(data));
      toast.success("Bienvenido al panel de administracion");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(typeof err.message === "string" ? err.message : "Error de autenticacion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F4F0] flex items-center justify-center px-4" style={{ fontFamily: "Outfit, sans-serif" }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Flag className="w-8 h-8 text-[#1B4D3E]" strokeWidth={1.5} />
            <h1 className="text-2xl font-bold text-[#0F172A]">cadii</h1>
          </div>
          <p className="text-sm text-[#64748B] font-medium">Cadii House</p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6">
          <h2 className="text-lg font-bold text-[#0F172A] mb-1" data-testid="admin-login-title">
            Acceso Administrador
          </h2>
          <p className="text-sm text-[#64748B] mb-6">Ingresa tus credenciales</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label className="text-sm font-medium text-[#0F172A] flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#1B4D3E]" /> Email
              </Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@cadii.app"
                required
                data-testid="admin-email-input"
              />
            </div>

            <div className="space-y-2">
              <Label className="text-sm font-medium text-[#0F172A] flex items-center gap-2">
                <Lock className="w-4 h-4 text-[#1B4D3E]" /> Contrasena
              </Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Tu contrasena"
                required
                data-testid="admin-password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1B4D3E] hover:bg-[#163F33] text-white py-5 text-base font-semibold rounded-xl"
              data-testid="admin-login-btn"
            >
              {loading ? "Ingresando..." : "Ingresar"}
            </Button>
          </form>
        </div>

        <div className="text-center mt-6">
          <button
            onClick={() => navigate("/")}
            className="text-sm text-[#64748B] hover:text-[#0F172A] transition-colors"
            data-testid="admin-back-btn"
          >
            Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
}
